import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Impressum } from "./components/impressum";
import { AGBs } from "./components/agbs";
import { ScrollToTop } from "./components/ScrollToTop";
import { NotFound } from "./components/notFound";
import { VideoSection } from "./components/videoSection";
import { Seo, breadcrumbSchema } from "./components/Seo";


// Smooth scroll initialization
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Titel und Descriptions je Route. Google zeigt rund 60 Zeichen Titel und
// 155 Zeichen Description an – längere Texte werden abgeschnitten.
// Der Ort steht bewusst im Titel: gesucht wird "Trockenbau München",
// nicht "Trockenbau".
// Die Pfade tragen bewusst einen Schrägstrich am Ende: Netlify liefert die
// prerenderten Seiten als impressum/index.html aus und leitet /impressum per
// 301 auf /impressum/ um. Canonical und og:url müssen die Endadresse nennen,
// sonst zeigen sie auf eine URL, die selbst nur weiterleitet.
const PAGE_META = {
  home: {
    title: "Trockenbau & Innenausbau München | Merdovic Trockenbau GmbH",
    description:
      "Meisterbetrieb für Trockenbau, Innenausbau, Klimadecken und Putzarbeiten in München. Über 10 Jahre Erfahrung – sauber, termintreu, alles aus einer Hand.",
    path: "/",
  },
  impressum: {
    title: "Impressum | Merdovic Trockenbau GmbH München",
    description:
      "Impressum und Anbieterkennzeichnung der Merdovic Trockenbau GmbH, Mittenwalder Str. 3, 81377 München.",
    path: "/impressum/",
  },
  agb: {
    title: "AGB | Merdovic Trockenbau GmbH München",
    description:
      "Allgemeine Geschäftsbedingungen der Merdovic Trockenbau GmbH für Trockenbau- und Innenausbauleistungen.",
    path: "/agb/",
  },
};

// data.json ist ein statischer Import – der Umweg über useState/useEffect
// erzwang nur einen zusätzlichen Render, bei dem alle Sektionen kurz
// "loading" angezeigt haben.
const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Navigation />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Seo {...PAGE_META.home} />
              <Header data={JsonData.Header} />
              <About data={JsonData.About} />
              <VideoSection />
              <Services data={JsonData.Services} />
              <Gallery data={JsonData.Gallery} />
              <Testimonials data={JsonData.Testimonials} />
              <Team data={JsonData.Team} />
              <Contact data={JsonData.Contact} />
            </>
          }
        />

        {/* New Pages */}
        <Route
          path="/impressum"
          element={
            <>
              <Seo
                {...PAGE_META.impressum}
                schema={breadcrumbSchema("Impressum", "/impressum")}
              />
              <Impressum />
            </>
          }
        />
        <Route
          path="/agb"
          element={
            <>
              <Seo {...PAGE_META.agb} schema={breadcrumbSchema("AGB", "/agb")} />
              <AGBs />
            </>
          }
        />
        <Route
          path="*"
          element={
            <>
              {/* noindex: Fehlerseiten gehören nicht in den Suchindex, sonst
                  konkurrieren beliebig viele Tippfehler-URLs mit der Startseite. */}
              <Seo
                title="Seite nicht gefunden | Merdovic Trockenbau GmbH"
                description="Die aufgerufene Seite existiert nicht oder wurde verschoben."
                path="/404"
                noindex
              />
              <NotFound />
            </>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
